import { c as _c } from "react/compiler-runtime";
import { Container } from '@repo/ui/icons';
import type { CmdkLoad } from './_hooks/use-cmdk-loads.ts';
const getLoadRoute = (load: CmdkLoad) => {
  let origin: null | string = null;
  let destination: null | string = null;
  for (const drop of load.drops) {
    if (drop.type === 'collection' && !origin && drop.name) {
      origin = drop.name;
    }
    if (drop.type === 'delivery' && drop.name) {
      destination = drop.name;
    }
  }
  return origin && destination ? `${origin} → ${destination}` : origin ?? destination;
};
export const LoadResultRow = t0 => {
  const $ = _c(18);
  const {
    load
  } = t0;
  let t1;
  if ($[0] !== load) {
    t1 = getLoadRoute(load);
    $[0] = load;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const route = t1;
  const t2 = load.company?.title;
  let t3;
  if ($[2] !== route || $[3] !== t2) {
    t3 = [t2, route].filter(Boolean);
    $[2] = route;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const metadata = t3.join(" \xB7 ");
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Container className="size-4 shrink-0 text-muted-foreground" data-sentry-element="Container" data-sentry-source-file="load-result-row.tsx" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `Load #${load.id}`;
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="truncate font-medium">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== metadata) {
    t7 = metadata && <span className="truncate text-xs text-muted-foreground">{metadata}</span>;
    $[8] = metadata;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <span className="flex min-w-0 flex-1 flex-col">{t6}{t7}</span>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== load.status) {
    t9 = load.status?.title && <span className="ml-auto shrink-0 rounded-full bg-muted px-2 py-0.5 text-[11px] text-muted-foreground">{load.status.title}</span>;
    $[13] = load.status;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <>{t4}{t8}{t9}</>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};